import { oldApiRequest, apiRequest } from 'api/apiRequest'

const getSongs = () => apiRequest('/v1/song/list?status=active', { songs: [] }).get()

const getGenres = () => apiRequest('/v1/genre/list', { genres: [] }).get()

const getSongsOld = () => oldApiRequest('music', []).get()

const getGenresOld = () => oldApiRequest('categories', []).get()

const getTranslations = (lang = '') =>
  oldApiRequest(`translation?language=${lang.toLowerCase()}`, []).get()

export const musicApi = {
  getGenres,
  getSongs,
  getSongsOld,
  getGenresOld,
  getTranslations,
}
